// Central role registry for the whole app.
// `key` is the value stored in the DB; `labelKey` maps to i18n translations.
// `badge` is a Tailwind class set for role badges.

export const ROLES = [
  { key: 'super_admin', labelKey: 'role.super_admin', badge: 'bg-violet-500/20 text-violet-700 border-violet-500/30' },
  { key: 'admin', labelKey: 'role.admin', badge: 'bg-blue-500/20 text-blue-700 border-blue-500/30' },
  { key: 'administration', labelKey: 'role.administration', badge: 'bg-indigo-500/20 text-indigo-700 border-indigo-500/30' },
  { key: 'direction', labelKey: 'role.direction', badge: 'bg-purple-500/20 text-purple-700 border-purple-500/30' },
  { key: 'coordinator', labelKey: 'role.coordinator', badge: 'bg-cyan-500/20 text-cyan-700 border-cyan-500/30' },
  { key: 'accountant', labelKey: 'role.accountant', badge: 'bg-emerald-500/20 text-emerald-700 border-emerald-500/30' },
  { key: 'receptionist', labelKey: 'role.receptionist', badge: 'bg-pink-500/20 text-pink-700 border-pink-500/30' },
  { key: 'librarian', labelKey: 'role.librarian', badge: 'bg-amber-500/20 text-amber-700 border-amber-500/30' },
  { key: 'driver', labelKey: 'role.driver', badge: 'bg-orange-500/20 text-orange-700 border-orange-500/30' },
  { key: 'service', labelKey: 'role.service', badge: 'bg-teal-500/20 text-teal-700 border-teal-500/30' },
  { key: 'teacher', labelKey: 'role.teacher', badge: 'bg-sky-500/20 text-sky-700 border-sky-500/30' },
  { key: 'student', labelKey: 'role.student', badge: 'bg-green-500/20 text-green-700 border-green-500/30' },
  { key: 'parent', labelKey: 'role.parent', badge: 'bg-rose-500/20 text-rose-700 border-rose-500/30' },
  // Internal finance/POS roles (kept valid but hidden from pickers)
  { key: 'viewer', labelKey: 'role.viewer', badge: 'bg-slate-500/20 text-slate-700 border-slate-500/30', internal: true },
  { key: 'cashier', labelKey: 'role.cashier', badge: 'bg-yellow-500/20 text-yellow-700 border-yellow-500/30', internal: true },
];

// Roles that can be picked in the UI (excludes internal finance/POS roles).
export const PICKABLE_ROLES = ROLES.filter((r) => !r.internal);

// Staff/non-teaching roles selectable when adding a teacher/staff member.
export const STAFF_ROLE_KEYS = [
  'teacher', 'coordinator', 'direction', 'administration',
  'accountant', 'receptionist', 'librarian', 'driver', 'service', 'admin',
];

export const getRoleMeta = (key) => ROLES.find((r) => r.key === key);

export const getRoleBadge = (key) =>
  getRoleMeta(key)?.badge || 'bg-slate-500/20 text-slate-700 border-slate-500/30';
